import React from 'react';
import StudentDashboardLayout from '../../../layouts/gcstudent/studentdashboardLayout/StudentDashboardLayout';
import StudentDashboardPage from '../../../subsreens/gcstudent/studentdashboardpage/StudentDashboardPage';


const StudentDashboard = () => {
  return (
    <StudentDashboardLayout>
        <StudentDashboardPage/>
    </StudentDashboardLayout>
  );
};

export default StudentDashboard;